module.exports = __webpack_public_path__ + "img/4.735f8f71.png";